<template>
  <div class="wrapper">
    <router-view></router-view>

    <div class="animated fadeIn">
      <div class="card" v-if="['settings'].indexOf($route.name) > -1">
        <div class="card-header"><i class="icon-settings"></i>Paramètres</div>

        <div class="card-block">
          <table class="table table-condensed">
            <tbody>
              <tr v-if="hasPermission(user, 'SETTINGS_CONCEPT_READ')">
                <td>
                  <router-link to="/settings/concepts">Concepts</router-link>
                </td>
              </tr>
              <tr v-if="hasPermission(user, 'SETTINGS_TEAM_READ')">
                <td>
                  <router-link to="/settings/teammembers">Equipe</router-link>
                </td>
              </tr>
              <tr v-if="hasPermission(user, 'SETTINGS_CONFIG_READ')">
                <td>
                  <router-link to="/settings/configs"
                    >Configurations</router-link
                  >
                </td>
              </tr>
              <tr v-if="hasPermission(user, 'SETTINGS_PAYMENTS_TYPE_READ')">
                <td>
                  <router-link to="/settings/payment-methods"
                    >Moyens de paiement</router-link
                  >
                </td>
              </tr>
              <tr v-if="hasPermission(user, 'SETTINGS_PRESTA_READ')">
                <td>
                  <router-link to="/settings/intervenants"
                    >Prestataires</router-link
                  >
                </td>
              </tr>
              <tr v-if="hasPermission(user, 'MERCHANTS_READ')">
                <td>
                  <router-link to="/settings/merchants">Sociétés</router-link>
                </td>
              </tr>
              <tr>
                <td>
                  <router-link
                    to="/settings/sap"
                    v-if="hasPermission($store.state.user, 'SETTINGS_SAP_READ')"
                  >
                    SAP
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Settings",
  computed: {
    ...mapState({
      user: (state) => state.user,
    }),
  },
};
</script>
